import type { CrossPlotStatistics } from '../types'
import { hasKeysOfUnknown, isNumber, isObject } from './common'

export const isXYSerieAggrList = (
  value: unknown,
): value is { XYSeriesCount: number; XYSerieAggrList: CrossPlotStatistics[] } =>
  isObject(value) &&
  hasKeysOfUnknown(value, 'XYSerieAggrList', 'XYSeriesCount') &&
  isNumber(value.XYSeriesCount)
